import { render, staticRenderFns } from "./RegisterAsDeveloper.vue?vue&type=template&id=b81b8648"
import script from "./RegisterAsDeveloper.vue?vue&type=script&lang=ts"
export * from "./RegisterAsDeveloper.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports